<div [class.has-design-context]="!!linkedTestCount" class="wrapper flex flex-col justify-between">
  <div class="heading text-type-6">
    {{ data?.testName }}
  </div>
  <div class="subheading text-type-10">
    {{ data?.bidItemName || '&nbsp;' }}
  </div>
  @if (data?.headingName) {
    <div
      class="subheading text-type-10"
      >
      {{ data?.headingName }}
      @if (data?.type==='withStations') {
        <span>({{ data?.list?.length }} station{{ data?.list?.length > 1 ? 's' : '' }}
        )</span>
      }
    </div>
  }
  @if (linkedTestCount) {
    <div class="card-linked-count text-type-14" data-testid="design-context-linked-count">{{ linkedCountText(linkedTestCount) }}</div>
  }
  @if (displayMatched) {
    <div class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}</div>
  }
</div>
